import classNames from 'classnames';
import React, { ChangeEventHandler, MouseEventHandler, useState } from 'react';

interface ScrubBarProps {
	onChange?: ChangeEventHandler;
	onMouseDown?: MouseEventHandler;
	onMouseUp?: MouseEventHandler;
	onMouseMove?: MouseEventHandler;
	disabled?: boolean;
	value?: number;
	wrapperClassNames?: any;
}

export default function ScrubBar(props: ScrubBarProps) {
	const [mouseOverValue, setMouseOverValue] = useState<string>('');
	const [mouseOverPosition, setMouseOverPosition] = useState<number>(0);

	const handleScrubBarStyle = (): React.CSSProperties => {
		const barValue = ((props.value ?? 0) * 100) + 0.1;
		return { background: `linear-gradient(to right, #FFFFFF 0%, #FFFFFF ${barValue}%, rgba(255, 255, 255, 0.3) ${barValue}%, rgba(255, 255, 255, 0.3) 100%)` };
	};

	return (
		<div className={classNames('align-items-center position-relative flex-grow scrub-bar-wrapper', props.wrapperClassNames)}>
			<div style={{ left: mouseOverPosition }} className='position-absolute margin-bottom-large white-space-nowrap info-bubble scrub-bar-value'>
				{mouseOverValue}
			</div>
			<input
				type='range'
				className='width-full border-radius-small scrub-click-area'
				onChange={props.onChange}
				onMouseDown={props.onMouseDown}
				onMouseUp={props.onMouseUp}
				onMouseMove={props.onMouseMove}
				value={props.value}
				max={1}
				min={0}
				step={0.01}
				style={handleScrubBarStyle()}
				disabled={props.disabled}
			/>
		</div>
	);
}